import { render, staticRenderFns } from "./CourseInfoPricing.vue?vue&type=template&id=75968b73&"
import script from "./CourseInfoPricing.vue?vue&type=script&lang=js&"
export * from "./CourseInfoPricing.vue?vue&type=script&lang=js&"
import style0 from "./CourseInfoPricing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports